<template>
  <div class="mensaje">
    <h2 class="mensaje__titulo titulo-h2">{{ mensaje.titulo }}</h2>
    <div class="mensaje__mensaje">
      <span class="mensaje__texto" v-html="mensaje.contenido"></span>
    </div>
    <i class="mensaje__icono" :class="'mensaje__icono-' + mensaje.imagen" />   
    <div v-if="mensaje.boton" class="mensaje__boton">
      <div class="form__group">
        <router-link class="waves-effect waves-light m-btn" :to="mensaje.boton.ruta">{{ mensaje.boton.etiqueta }}</router-link>  
      </div> 
    </div>   
    <div v-if="mensaje.enlace1 || mensaje.enlace2" class="mensaje__enlaces">
      <div class="form-fields__links">
        <router-link v-if="mensaje.enlace1" class="form-fields__links-link" :to="mensaje.enlace1.ruta">{{ mensaje.enlace1.etiqueta }}</router-link>
        <router-link v-if="mensaje.enlace2" class="form-fields__links-link" :to="mensaje.enlace2.ruta">{{ mensaje.enlace2.etiqueta }}</router-link>
      </div> 
    </div>   
    <div>
    </div>
  </div>    
</template>

<script>
export default {
  computed:{
    mensaje(){
      return this.$store.getters.mensaje 
    }
  }
  
}
</script>